<div class="flex items-center" [class.gap-2]="hasContent">
  <mat-spinner *ngIf="loading" [diameter]="diameter"></mat-spinner>
  <span>
    <ng-content></ng-content>
  </span>
</div>
